<div class="py-80px gap-y-30px relative">
    <companyid-feature-slider (chooseFeatureTitle)="onSelectFeature($event)" [currentIndex]="activeId()" />
    <companyid-content-wrapper classNames="tab:px-5 mob:px-5 w-full mt-30px flex-col tab:mt-60px z-10">
        <companyid-carousel-animation
            [currentIndex]="activeId()"
            [contentItemsLength]="featuresContent.length"
            (onChangeSlide)="onSelectFeature($event)"
            className="flex absolute bottom-10 px-40px tab:px-5 mob:bottom-[300px] mob:px-5 w-1/2 mob:w-full"
        >
            @for (feature of featuresContent; let i = $index; track feature.title) {
                <div class="w-full flex-shrink-0 relative">
                    <companyid-feature-item
                        [feature]="feature"
                        class="flex w-full"
                        className="tab:h-[435px] mob:h-[710px] !max-w-full"
                    >
                    </companyid-feature-item>
                </div>
            }
        </companyid-carousel-animation>

        <div class="flex w-full mt-30px tab:mt-60px items-center gap-30px">
            <a i18n="@@button-more-feature" class="button-black-outline-small" routerLink="/features">
                More features
            </a>

            <button i18n="@@button-check-out-our-prices" class="button-ghost-gray-with-arrow-top" routerLink="/pricing">
                Check out our prices
                <companyid-arrow color="gray" position="top-right" />
            </button>
        </div>
    </companyid-content-wrapper>

    <img
        [ngSrc]="'gray-vector' | asset: 'home/home-features' : 'webp'"
        fill
        alt="gray-vector"
        class="absolute object-cover mob:hidden tab:hidden"
    />
</div>
